import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "search-search-result" }
const _hoisted_2 = { class: "text text-left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  href: "javascript:void(0)",
  class: "io-mfe-ig-partial-code-result"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "code-text" }

import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {SearchViewRecord} from 'src/services/search-service';
import {ref, watch} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsList',
  setup(__props) {

const searchStore = useSearchStore();
const {searchResults} = storeToRefs(searchStore);
const resultItem = ref<number>();

watch(
  searchResults,
  (newSearchResults) => {
    if (newSearchResults && newSearchResults.length > 0) {
      resultItem.value = newSearchResults[0].data_id;
    }
  }
);
function onSelectionChanged(searchResult: SearchViewRecord) {
  searchStore.getResultDetails(searchResult);
  resultItem.value = searchResult.data_id;
}

function addCode(code?: string) {
  if (code) {
    searchStore.addDxOrProcCode(code);
  }
}

function shouldShowAddCode(record: SearchViewRecord) {
  return record?.codes?.[0] && !record?.codes?.[0]?.endsWith('-') && (record?.codes?.[0]?.length === 7 || !searchStore.getBookCode?.startsWith('ICD10PCS'));
}

function hasPartialCode(record: SearchViewRecord) {
  return record?.codes?.[0] && (record?.codes?.[0]?.endsWith('-') || (record?.codes?.[0]?.length != 7 && searchStore.getBookCode?.startsWith('ICD10PCS')));
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResults) || [], (searchResultItem) => {
          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            key: searchResultItem.id,
            modelValue: resultItem.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resultItem).value = $event)),
            clickable: "",
            class: _normalizeClass('search-search-result-item' + (resultItem.value===searchResultItem.data_id ? ' search-search-result-item__active' : '')),
            onClick: ($event: any) => (onSelectionChanged(searchResultItem))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { class: "search-search-result-item-section" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      innerHTML: searchResultItem.text
                    }, null, 8, _hoisted_3),
                    (hasPartialCode(searchResultItem))
                      ? (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(searchResultItem?.codes?.[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (shouldShowAddCode(searchResultItem))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "code-wrapper",
                        onClick: _withModifiers(($event: any) => (addCode(searchResultItem?.codes?.[0])), ["stop"])
                      }, [
                        _createVNode(_component_q_icon, {
                          class: "code-icon",
                          name: "fa-light fa-circle-plus",
                          size: "14px"
                        }),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(searchResultItem?.codes?.[0]), 1)
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["modelValue", "class", "onClick"])), [
            [_directive_ripple]
          ])
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})